import { Platform } from 'react-native';
import { showError, showSuccess } from '../../shared/ui/appToast';
import { supabase } from '../../shared/supabase/supabaseClient';
import { useAuthStore } from '../store/useAuthStore';
import { userFacingSupabaseAuthMessage } from './authMessages';
import { reportAuthFailure } from './authObservability';
import { normalizeEmail } from './authFormValidation';

/**
 * URL pública de `/auth/reset-password` (PWA Expo en app.vuelto; no el portal `www` salvo que lo sobreescribas con env).
 * Un `redirect_to` al solo origen hace perder el hash con el token al redirigir a `/landing` en un host distinto.
 */
export function getPasswordResetRedirectUrl(): string {
  const raw = process.env.EXPO_PUBLIC_PASSWORD_RESET_URL?.trim();
  if (raw) {
    try {
      const u = new URL(raw);
      const path = u.pathname.replace(/\/$/, '') || '/';
      if (path === '/' || path === '') {
        u.pathname = '/auth/reset-password';
        u.search = '';
        u.hash = '';
        return u.toString().replace(/\/$/, '');
      }
      return raw.replace(/\/$/, '');
    } catch {
      return raw;
    }
  }
  const base =
    process.env.EXPO_PUBLIC_EXPO_WEB_APP_ORIGIN?.trim().replace(/\/$/, '') ||
    'https://app.vuelto.ar';
  return `${base}/auth/reset-password`;
}

export const sendPasswordResetEmail = async (email: string) => {
  const authStore = useAuthStore.getState();
  authStore.setError(undefined);
  try {
    const { error } = await supabase.auth.resetPasswordForEmail(normalizeEmail(email), {
      redirectTo: getPasswordResetRedirectUrl(),
    });
    if (error) throw error;
    /** El enlace abre el navegador (no la app): avisarlo evita que parezca que se rompió. */
    const nativeHint =
      Platform.OS === 'web'
        ? ''
        : ' El enlace abre el navegador; cambiás la clave ahí y volvés a la app.';
    showSuccess(
      'Revisá tu correo',
      `Te enviamos un enlace para cambiar la contraseña. Mirá también el spam.${nativeHint}`,
    );
  } catch (err: any) {
    const message = userFacingSupabaseAuthMessage(err?.message ?? '', 'reset', {
      code: err?.code,
      status: err?.status,
    });
    authStore.setError(message);
    showError('No pudimos enviar el correo', message);
    reportAuthFailure('reset', err, { title: 'No pudimos enviar el correo' });
  }
};
